<template>
  <UiCollapsable
    class="filter-item"
    :active="filter.activeOptionsCount"
    :reference="filter.key"
    :label="filter.label"
    :open="!!filter.isExpanded"
  >
    <template #icon_before>
      <IconPlus
        class="collapsable__icon icon icon--plus"
        aria-hidden="true"
      />
    </template>

    <template #icon_after>
      <template v-if="filter.isInfoVisible && filter.infoText">
        <button
          type="button"
          class="filter-item__tooltip"
          :aria-label="$t('More info about {name} filter', { name: $t(filter.label) })"
          @click="tooltip.open"
        >
          <IconInfo class="icon icon--tooltip" />
        </button>

        <LazyUiDialog :name="`tooltip__${filter.key}`">
          <template #dialogHeader>
            {{ $t(filter.label) }}
          </template>

          <p>{{ filter.infoText }}</p>
        </LazyUiDialog>
      </template>

      <IconMin
        class="collapsable__icon icon icon--min"
      />
    </template>

    <LazyFilterLinks
      v-if="['cat', 'category'].includes(filter.key)"
      :filter="filter"
    />
    <LazyFilterSlider
      v-else-if="filter.type === 'range' || filter.type === 'slider'"
      :filter="filter"
      @filter-reset="filterResetAndUpdate(filter.key)"
      @filter-apply="filterApplyAndUpdate(filter.key)"
      @input="debounceGetExpectedTotal"
    />

    <LazyFilterOptions
      v-else-if="filter.type === 'default' || filter.type === 'swatch'"
      :filter="filter"
      @option-toggle="(optionKey: string) => toggle(filter.key, optionKey)"
      @filter-reset="filterResetAndUpdate(filter.key)"
      @filter-apply="filterApplyAndUpdate(filter.key)"
    />
    <dev-only v-else>
      <pre>{{ filter }}</pre>
    </dev-only>
  </UiCollapsable>
</template>

<script setup lang="ts">
const props = defineProps<{
  filter: any
}>()

const meta = inject('meta', ref())

const tooltip = useUiDialog(`tooltip__${props.filter.key}`)

const {
  optionToggle,
  filterApply,
  filterRemove,
  filtersApplyAll,
  getExpectedTotal,
} = useCatalogFilters(meta)

function toggle(filterKey: any, optionKey: any) {
  optionToggle(filterKey, optionKey)
  getExpectedTotal()
}

function filterApplyAndUpdate(filterKey: string) {
  filterApply(filterKey)
  filtersApplyAll()
}

function filterResetAndUpdate(filterKey: string) {
  filterRemove(filterKey) // Empty all active option in this filter
  getExpectedTotal()
  filtersApplyAll()
}

const debounceGetExpectedTotal = useDebounceFn(() => {
  getExpectedTotal()
}, 250)
</script>

<style>
@import url("~layers/app/components/Filter/Item.css");
</style>
